import classNames from 'classnames'
import { ReactNode, useEffect, useCallback } from 'react'
import { Toaster, toast, useToaster } from 'react-hot-toast'
import type { ToastOptions, ToasterProps } from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { removeSnackbarAction } from '../../actions/snackbarActions'
/*
Implemented by react-hot-toast: https://react-hot-toast.com/

Any custom props passed into <Toaster/> are for global toast components.
while invoking setToast, it accepts another toastOptions for the single toast at the time.

for more API info: https://react-hot-toast.com/docs/toast
*/

const defaultToastOptions = {
  className: 'babu-toast',
  duration: Infinity,
}

export const setToast = (
  children: string | ReactNode,
  toastOptions?: ToastOptions,
) =>
  toast.custom(
    <>
      {typeof children === 'string' ? (
        <div className="bg-text900 flex justify-center items-center rounded">
          <div className="text-white text-paragraph px-m py-s">{children}</div>
        </div>
      ) : (
        children
      )}
    </>,
    Object.assign({}, defaultToastOptions, toastOptions),
  )

export default function Toast(props: ToasterProps) {
  const dispatch = useDispatch()
  const { toasts } = useToaster()

  const handleDismissToast = useCallback(() => {
    if (toasts.length > 0) {
      toast.dismiss()
      dispatch(removeSnackbarAction(-1))
    }
  }, [dispatch, toasts.length])

  useEffect(() => {
    document.addEventListener('mousedown', handleDismissToast)
    return () => {
      document.removeEventListener('mousedown', handleDismissToast)
    }
  }, [handleDismissToast])

  return (
    <Toaster
      {...props}
      containerClassName={classNames(
        'babu-toaster-container',
        props.containerClassName,
      )}
    />
  )
}
